import React, { useEffect, useState } from "react";
import axios from "axios";
import Navigation from "../../components/Navigation";
import { Link, useNavigation } from "react-router-dom";
import Loader from "../../components/Loader";
import NoData from "../../components/NoData";
import { toast } from "react-toastify";
import Constants from "../Variables/Constants";

const AddressPage = () => {
  const [addresses, setAddresses] = useState([]);
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("token");
  //const navigate = useNavigation();

  const fetchAddresses = async () => {
    try {
      const response = await axios.get(Constants.getUrls.getUserAddress, {
        headers: { Authorization: token },
      });

      if (response.data.status === "success") {
        setAddresses(response.data.data);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
      try {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(error.message);
        const { status, message } = error.response.data
        if (status === 401 && message === "Unauthorized!") {
          localStorage.removeItem("token");
          window.location.href = "/";
        }
        setLoading(false);
      } catch (error) {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(error.message);
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    fetchAddresses();
  }, []);

  const handelDeleteAddress = (id) => {
    try {

      axios
        .delete(`${Constants.deleteUrls.deleteAddress}/${id}`, {
          headers: { Authorization: token },
        })
        .then((response) => {
          if (response.data.status === "success") {
            toast.clearWaitingQueue();
            toast.dismiss();
            toast.success("Address deleted successfully!");
            setAddresses(addresses.filter((address) => address._id !== id));
          }
        })
        .catch((error) => {
          console.error("Error deleting address:", error);
        });
    } catch (error) {
      try {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(error.message);
        const { status, message } = error.response.data
        if (status === 401 && message === "Unauthorized!") {
          localStorage.removeItem("token");
          window.location.href = "/";
        }
      } catch (error) {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(error.message);
      }
    }
  };


  const handleStatusUpdate = async (product) => {
    try {
      // Update existing address
      await axios.put(`${Constants.putUrls.updateUserAddress}/${product._id}`, { is_default: product.is_default === "yes" ? "no" : "yes" }, {
        headers: {
          Authorization: token,
        },
      });
      toast.clearWaitingQueue();
      toast.dismiss();
      toast.success("Status updated successfully!");
      fetchAddresses();
    } catch (error) {
      try {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(error.message);
        const { status, message } = error.response.data;
        if (status === 401 && message === "Unauthorized!") {
          localStorage.removeItem("token");
          window.location.href = "/";
        }
      } catch (error) {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(error.message);
      }
    }
  };

  return (
    <div className="container-fluid">
      <Navigation />

      <div className="container">
        <div className="d-flex justify-content-between align-items-center gap-5 flex-wrap">
          <p className="fs-22">Address Details</p>

          <Link to={"/Add"}>
            <button className="btn bg-blue text-white fs-16">
              <img loading="lazy"  className="p-2" src="/plus.png" alt="Add" />
              Add Address
            </button>
          </Link>
        </div>

        {loading ? (
          <Loader />
        ) : addresses.length === 0 ? (
          <NoData
            image={"/noAddress.png"}
            text={"Address details Not Added Yet!"}
          />
        ) : (
          <div className="row gap-lg-0 gap-4 mt-4 pb-lg-5 pb-2">
            {addresses.map((address) => (
              <div key={address._id} className="col-lg-4 col-md-6 col-12">
                <div className="address shadow-cc rounded-4 d-flex overflow-hidden justify-content-between align-items-center bg-light-gray p-5"
                  style={{ boxShadow: address.is_default === "yes" ? "0px 0px 10px 10px #e4dccd" : "", cursor: "pointer" }}
                  onClick={() => {
                    handleStatusUpdate(address);
                  }}
                >
                  <div>
                    <h2>{address.address_name}</h2>
                    <p className="fs-14">
                      {address.address}, {address.city}
                      {address.state ? `, ${address.state}` : ""}, {address.country},{" "}
                      {address.postal_code}
                    </p>
                  </div>
                  <div className="d-flex ms-4 p-3 bg-white justify-content-center rounded-4 h-cccc gap-4 ">
                    <Link to={`/add/${address._id}`} onClick={e => {
                      // e.preventDefault();
                      e.stopPropagation();
                    }}>
                      <img loading="lazy"  className="cursor" src="/darkEdit.png" alt="Edit" />
                    </Link>
                    <img loading="lazy" 
                      className="cursor"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        handelDeleteAddress(address._id)
                      }}
                      src="https://img.icons8.com/emoji/20/cross-mark-emoji.png"
                      alt="Delete"
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default AddressPage;
